"use client";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "flowbite-react";

export default function AutoscaleBillingNotice({ open, setOpen }) {
  return (
    <>
      <Modal show={open} size="md" onClose={() => setOpen(false)} dismissible>
        <ModalHeader>Autoscale Billing</ModalHeader>
        <ModalBody>
          <div className="space-y-4">
            <p className="text-sm leading-6 text-gray-700">
              The resources created within an autoscale group are billed the
              same way as if they were created individually outside the group.
            </p>

            <div className="rounded-lg bg-gray-50 p-4">
              <h4 className="mb-2 text-sm font-semibold text-gray-800">
                Recommendation
              </h4>
              <p className="text-sm text-gray-700">
                Maintain in your wallet an amount equal to:
              </p>
              <ul className="mt-2 list-disc list-inside text-sm text-gray-800">
                <li>Total cost of the maximum number of servers</li>
                <li>Plus the cost of one pool per server</li>
              </ul>
            </div>

            <div className="rounded-lg border border-gray-200 p-4">
              <h4 className="mb-3 text-sm font-semibold text-gray-800">
                Example
              </h4>

              <div className="grid grid-cols-1 gap-2 text-sm">
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">One server</span>
                  <span className="font-medium">₦8,000</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Each pool member</span>
                  <span className="font-medium">₦5,000</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-600">Max servers</span>
                  <span className="font-medium">4</span>
                </div>

                <hr className="my-2 border-gray-200" />

                <div className="flex items-center justify-between">
                  <span className="text-gray-700">
                    Servers total (₦8,000 × 4)
                  </span>
                  <span className="font-semibold">₦32,000</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-700">Pool total (₦5,000 × 4)</span>
                  <span className="font-semibold">₦20,000</span>
                </div>

                <div className="mt-2 rounded-md bg-emerald-50 px-3 py-2">
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-emerald-800">
                      Recommended wallet balance
                    </span>
                    <span className="font-bold text-emerald-900">₦52,000</span>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-xs text-gray-500">
              Note: Actual costs depend on your active pricing; adjust server
              and pool rates and the maximum server count accordingly.
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            style={{ color: "red", border: "1px solid red" }}
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
